import { fetchVehicles, fetchVehicleTypes } from '@/api/vehicles'

const vehiclesStore = {
  state: {
    all: {
      list: [],
    },
    types: {
      list: [],
    },
  },
  getters: {
    'vehiclesAllList': state => {
      return state.all.list
    },
    'vehiclesTypesList': state => {
      return state.types.list
    },
  },
  mutations: {
    'vehicles.setAllList': (state, payload) => {
      state.all.list = payload
    },
    'vehicles.setTypesList': (state, payload) => {
      state.types.list = payload
    },
  },
  actions: {
    'vehicles.fetchAll': ({ commit }) => {
      return new Promise((resolve, reject) => {
        fetchVehicles().then(res => {
          commit('vehicles.setAllList', res.data.data)
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },
    'vehicles.fetchTypes': ({ commit }) => {
      return new Promise((resolve, reject) => {
        fetchVehicleTypes().then(res => {
          commit('vehicles.setTypesList', res.data.data)
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },
  },
}

export default vehiclesStore
